// @flow

import * as React from 'react';
import { BUSINESS_PLAN_COLORS } from '../../../../const';

function Legend() {
  return (
    <div className="legend-container">
      {
        Object.entries(BUSINESS_PLAN_COLORS).map((entry: string) => (
          <div className="legend-item business-plan" key={entry[0]}>
            <div className="color-item" style={{ backgroundColor: entry[1] }} />
            {entry[0]}
          </div>
        ))
      }
    </div>
  );
}

export default Legend;
